<template>
  <AppModal
    :is-open="isOpen"
    :title="currentPlayerName"
    :subtitle="label"
    size="sm"
    @close="emit('close')"
  >
    <div class="number-grid">
      <button
        v-for="n in maxUnits + 1"
        :key="n - 1"
        type="button"
        class="number-button"
        :class="{ 'is-current': n - 1 === initialValue }"
        :aria-pressed="n - 1 === initialValue"
        :disabled="limit !== null && n - 1 > limit"
        @click="emit('select', n - 1)"
      >
        {{ n - 1 }}
      </button>
    </div>
  </AppModal>
</template>

<script setup>
import AppModal from './AppModal.vue';

defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  maxUnits: {
    type: Number,
    required: true
  },
  currentPlayerName: {
    type: String,
    required: true
  },
  label: {
    type: String,
    default: ''
  },
  initialValue: {
    type: Number,
    default: null
  },
  limit: {
    type: Number,
    default: null
  }
});

const emit = defineEmits(['select', 'close']);
</script>

<style scoped>
.number-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  padding-bottom: 0.5rem;
}

.number-button {
  min-height: 52px;
  border-radius: var(--radius-control);
  border: 1px solid var(--card-line);
  background-color: var(--control);
  color: var(--ink);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.5rem;
  transition:
    background-color 0.15s,
    border-color 0.15s;
}

.number-button:hover:not(:disabled) {
  border-color: var(--ink-muted);
}

.number-button.is-current {
  background-color: var(--strong);
  border-color: var(--strong);
  color: var(--on-strong);
}

.number-button:disabled {
  opacity: 0.3;
}
</style>
